import { getThemeSpacingAsNumber } from '../../theme/foundations/spaces';
var headerGap = 'm';
var headerWidth = '100%';
var labelMaxWidth = '80%';
export var collapsibleTheme = {
  baseStyle: {
    header: {
      display: 'flex',
      width: headerWidth,
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: headerGap
    },
    labelAndIcon: {
      display: 'flex',
      gap: 'xxs',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textStyle: 'body4Semi',
      color: 'neutral.darker',
      width: 'max-content',
      maxWidth: labelMaxWidth,
      flexGrow: 1,
      _hover: {
        color: 'neutral.darkest',
        cursor: 'pointer'
      },
      '&[data-full-view=true]': {
        width: '100%',
        justifyContent: 'space-between',
        maxWidth: '100%'
      },
      _active: {
        color: 'neutral.darkest'
      }
    },
    secondaryLabel: {
      display: 'flex',
      alignItems: 'center',
      textStyle: 'body4Semi',
      color: 'neutral.darker',
      flexShrink: 0,
      maxWidth: "calc(".concat(headerWidth, " - ").concat(labelMaxWidth, " - ").concat(getThemeSpacingAsNumber(headerGap), "px)")
    }
  }
};
//# sourceMappingURL=Collapsible.theme.js.map